import React from "react";
import AppMenuitem from "./AppMenuitem";
import { MenuProvider } from "./context/menucontext";
import { AppMenuItem } from "../types/types";
import { useAuth } from "../utils/auth";
import { Role } from "../services/auth/auth.dto";

const AppMenu = () => {
  const auth = useAuth();

//   const menuItems = [
//     {
//       label: "Anketler",
//       icon: "pi pi-fw pi-list",
//       items: [
//         {
//           label: "Anket 1",
//           icon: "pi pi-fw pi-file",
//           items: [
//             { label: "Anket 1.1", icon: "pi pi-fw pi-file-edit", to: `/calistay/anket-alan-1` },
//             { label: "Anket 1.1 Sonuc", icon: "pi pi-fw pi-chart-bar", to: `/calistay/anket-alan-1-sonuc` },
//             { label: "Anket 1.2", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-alan-2" },
//             { label: "Anket 1.2 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-alan-2-sonuc" },
//             { label: "Anket 1.3", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-alan-3" },
//             { label: "Anket 1.3 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-alan-3-sonuc" },
//             { label: "Anket 1.4", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-alan-4" },
//             { label: "Anket 1.4 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-alan-4-sonuc" },
//             { label: "Anket 1.5", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-alan-5" },
//             { label: "Anket 1.5 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-alan-5-sonuc" },
//             { label: "Anket 1.6", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-alan-6" },
//             { label: "Anket 1.6 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-alan-6-sonuc" },
//             { label: "Anket 1.7", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-alan-7" },
//             { label: "Anket 1.7 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-alan-7-sonuc" }
//           ]
//         },
//         {
//           label: "Anket 2",
//           icon: "pi pi-fw pi-file",
//           items: [
//             { label: "Anket 2.1", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-yorum/1" },
//             { label: "Anket 2.1 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-yorum-sonuc/1" },
//             { label: "Anket 2.2", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-yorum/2" },
//             { label: "Anket 2.2 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-yorum-sonuc/2" },
//             { label: "Anket 2.3", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-yorum/3" },
//             { label: "Anket 2.3 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-yorum-sonuc/3" },
//             { label: "Anket 2.4", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-yorum/4" },
//             { label: "Anket 2.4 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-yorum-sonuc/4" },
//             { label: "Anket 2.5", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-yorum/5" },
//             { label: "Anket 2.5 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-yorum-sonuc/5" },
//             { label: "Anket 2.6", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-yorum/6" },
//             { label: "Anket 2.6 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-yorum-sonuc/6" },
//             { label: "Anket 2.7", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket-yorum/7" },
//             { label: "Anket 2.7 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket-yorum-sonuc/7" }
//           ]
//         },
//         {
//           label: "Anket 3",
//           icon: "pi pi-fw pi-file",
//           items: [
//             { label: "Anket 3.1", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket4/1" },
//             { label: "Anket 3.1 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket4-sonuc/1" },
//             { label: "Anket 3.2", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket4/2" },
//             { label: "Anket 3.2 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket4-sonuc/2" },
//             { label: "Anket 3.3", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket4/3" },
//             { label: "Anket 3.3 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket4-sonuc/3" },
//             { label: "Anket 3.4", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket4/4" },
//             { label: "Anket 3.4 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket4-sonuc/4" },
//             { label: "Anket 3.5", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket4/5" },
//             { label: "Anket 3.5 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket4-sonuc/5" },
//             { label: "Anket 3.6", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket4/6" },
//             { label: "Anket 3.6 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket4-sonuc/6" },
//             { label: "Anket 3.7", icon: "pi pi-fw pi-file-edit", to: "/calistay/anket4/7" },
//             { label: "Anket 3.7 Sonuc", icon: "pi pi-fw pi-chart-bar", to: "/calistay/anket4-sonuc/7" }
//           ]
//         }
//       ]
//     }
//   ];

  const model: AppMenuItem[] = [
    {
      label: "Ana Sayfa",
      items: [{ label: "Ana Menu", icon: "pi pi-fw pi-home", to: "/app/homepage" }]
    },
    {
      label: "Anketler",
      icon: "pi pi-fw pi-th-large",
      to: "/pages",
      items: [
        {
          label: "Stratejik Anket",
          icon: "pi pi-fw pi-clipboard",
          to: "/app/stratejik-anket"
        },
        {
          label: "Çevresel Göstergeler Anketi",
          icon: "pi pi-fw pi-clipboard",
          to: "/app/cevresel-gostergeler-anket"
        }
      ]
    },
    {
      label: "Anket Sonuçları",
      icon: "pi pi-fw pi-cog",
      to: "/pages",
      visible: auth.getUser().role === Role.ADMIN,
      items: [
        {
          label: "Stratejik Anket Raporu",
          icon: "pi pi-fw pi-chart-pie",
          to: "/admin/stratejik-rapor"
        },
        {
          label: "Çevresel Göstergeler Raporu",
          icon: "pi pi-fw pi-chart-line",
          to: "/admin/cevresel-gostergeler-rapor"
        }
      ]
    },
    {
      label: "Sayfalar",
      icon: "pi pi-fw pi-th-large",
      to: "/pages",
      // Kayıt olmayan kullanıcılar da bu menüyü görebilir
      visible: true,
      items: [
        {
          label: "Hesaplama",
          icon: "pi pi-fw pi-calculator",
          to: "/app/karbonayakizi"
        },
        {
          label: "Raporlama",
          icon: "pi pi-fw pi-file-pdf",
          to: "/app/rapor"
        },
        {
          label: "Analiz",
          icon: "pi pi-fw pi-chart-line",
          to: "/app/grafik"
        },
        {
          label: "Eğitim",
          icon: "pi pi-fw pi-book",
          to: "/app/egitim"
        },
        {
          label: "İş Sürekliliği Planı",
          icon: "pi pi-fw pi-sync",
          to: "/app/is-surekliligi"
        },
        {
          label: "OSBÜK Bülten",
          icon: "pi pi-fw pi-envelope",
          to: "/app/bulten"
        },
        //{
        //   label: "Stratejik Plan Çalışması",
        //   icon: "pi pi-fw pi-home",
        //   to: "/app/stratejik-plan"
        //   //   visible:
        //   //     auth.getUser().role === Role.User ||
        //   //     auth.getUser().role === Role.OsbukUser ||
        //   //     auth.getUser().role === Role.Admin
        // },
        {
          label: "Başkan Mesajı",
          icon: "pi pi-fw pi-user",
          to: "/app/baskan-mesaj"
        }
      ]
    },
    {
      label: "Topluluk Sayfaları",
      icon: "pi pi-fw pi-users",
      to: "/pages",
      //visible: auth.getUser().role === Role.OSBUK_USER || auth.getUser().role === Role.ADMIN,
      items: [
        {
          label: "Forum",
          icon: "pi pi-fw pi-comments",
          to: "/app/forum-homepage",
          visible: auth.getUser().role === Role.OSBUK_USER || auth.getUser().role === Role.ADMIN
        },
        {
          label: "Stratejik Plan Çalışması",
          icon: "pi pi-fw pi-compass",
          to: "/app/stratejik-plan"
          //visible: auth.getUser().role === Role.OSBUK_USER || auth.getUser().role === Role.ADMIN
        },
        {
          label: "Merkezle YZ Sohbet",
          icon: "pi pi-fw pi-comment",
          to: "/app/yapay-zeka",
          visible: auth.getUser().role === Role.OSBUK_USER || auth.getUser().role === Role.ADMIN
        }
      ]
    },
    {
      label: "Yönetim Paneli",
      icon: "pi pi-fw pi-cog",
      to: "/pages",
      visible: auth.getUser().role === Role.ADMIN,
      items: [
        {
          label: "Belgeler",
          icon: "pi pi-fw pi-folder",
          to: "/admin/belgeler"
        },
        {
          label: "Kullanıcılar",
          icon: "pi pi-fw pi-users",
          to: "/admin/users"
        },
        {
          label: "Toplu Email Gönder",
          icon: "pi pi-fw pi-send",
          to: "/admin/send-mass-email"
        },
        // {
        //   label: "Anket Sonuçları",
        //   icon: "pi pi-fw pi-chart-bar",
        //   to: "/admin/survey-results"
        // },
        {
          label: "Sayfa İçerikleri Düzenleme",
          icon: "pi pi-fw pi-chart-bar",
          to: "/admin/page-edit"
        }
      ]
    }
    // {
    //   label: "Anketler",
    //   icon: "pi pi-fw pi-briefcase",
    //   items: [
    //     {
    //       label: "Anket 1",
    //       icon: "pi pi-fw pi-calculator",
    //       to: `/calistay/anket-alan-${masaNo}`
    //     },
    //     {
    //       label: "Anket 1 Sonuc",
    //       icon: "pi pi-fw pi-file",
    //       to: `/calistay/anket-alan-${masaNo}-sonuc`
    //     },
    //     {
    //       label: "Anket 2",
    //       icon: "pi pi-fw pi-chart-scatter",
    //       to: `/calistay/anket-yorum/${masaNo}`
    //     },
    //     {
    //       label: "Anket 2 Sonuc",
    //       icon: "pi pi-fw pi-user",
    //       to: `/calistay/anket-yorum-sonuc/${masaNo}`
    //     },
    //     {
    //       label: "Anket 3",
    //       icon: "pi pi-fw pi-info-circle",
    //       to: `/calistay/anket4/${masaNo}`
    //     },
    //     {
    //       label: "Anket 3 Sonuc",
    //       icon: "pi pi-fw pi-bell",
    //       to: `/calistay/anket4-sonuc/${masaNo}`
    //     }
    //   ]
    // }
  ];

  //   if (localStorage.getItem("role") === "0") {
  //     model.push(...menuItems);
  //   }

  return (
    <MenuProvider>
      <ul className="layout-menu">
        {model.map((item, i) => {
          return !item?.seperator ? (
            <AppMenuitem item={item} root={true} index={i} key={item.label} />
          ) : (
            <li className="menu-separator"></li>
          );
        })}
      </ul>
    </MenuProvider>
  );
};

export default AppMenu;
